/* ============================================================
   ms-product.js  -  Msofas product page (hướng C v2)
   1. Plate 1: media xếp lớp + thumbnail (ô 360° đầu); viewer preload ẩn sau load; Easify → viewer.features
   2. Skeleton Easify tắt khi app render
   3. Information popup: <dialog> native
   ============================================================ */
(function () {
  var root = document.querySelector('[data-ms-pd]');
  if (!root) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var title = root.getAttribute('data-title') || 'This sofa';

  /* ── 0. ĐƠN VỊ: tab cm | inch (mặc định cm, quyết định 2026-09-20). Mỗi số đo render cả hai
     <span class="cm"> + <span class="in">; CSS ẩn bên không chọn theo [data-ms-unit] trên root — MỘT state
     cho cả bảng Specification và popup Size guide. Chuỗi nhiều số ("77 / 95 cm") đổi từng số. */
  function inch(cm) { return Math.round(cm / 2.54) + '″'; }
  function both(cm, ins) { return '<span class="cm">' + cm + '</span><span class="in">' + ins + '</span>'; }
  function convertCm(el) {
    if (!el) return;
    var t = el.textContent.trim();
    var m = t.match(/^([\d.\s\/–×x-]+?)\s*cm$/);
    if (m) {   // ô bảng chỉ có số + cm
      var ins = m[1].split(/([\/–×x-])/).map(function (p) { return /^\s*[\d.]+\s*$/.test(p) ? inch(+p) : ' ' + p + ' '; }).join('').replace(/\s+/g, ' ').trim();
      el.innerHTML = both(t, ins);
      return;
    }
    el.innerHTML = el.innerHTML.replace(/(\d+(?:\.\d+)?)\s*cm\b/g, function (_, n) { return both(n + ' cm', inch(+n)); });
  }
  root.querySelectorAll('.ms-pd__tbl td').forEach(convertCm);
  root.querySelectorAll('.ms-pd__units').forEach(function (u) {   // chỉ hiện tab khi bảng ngay dưới có số đo
    if (u.nextElementSibling && u.nextElementSibling.querySelector('.in')) u.hidden = false;
  });
  root.addEventListener('click', function (e) {
    var b = e.target.closest('.ms-pd__units button'); if (!b) return;
    root.setAttribute('data-ms-unit', b.dataset.unit);
    root.querySelectorAll('.ms-pd__units button').forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.unit === b.dataset.unit)); });
  });

  /* ── 0b. HEADER STICKY (bar + header) che đầu viewport 165px desktop / 134px mobile. Đo và phát --ms-stick
     để scroll-margin-top của mọi anchor (hero, Order, Reviews) trừ đúng phần bị che —
     không có biến CSS sẵn, và chiều cao đổi theo breakpoint. */
  function stick() {
    var h = 0;
    document.querySelectorAll('.ms-hdr--bar, .shopify-section-group-header-group').forEach(function (e) {
      if (/sticky|fixed/.test(getComputedStyle(e).position)) h = Math.max(h, e.getBoundingClientRect().bottom);
    });
    root.style.setProperty('--ms-stick', Math.round(h) + 'px');
  }
  stick(); window.addEventListener('resize', stick);

  /* ── 1. PLATE 1 — media xếp lớp + thumbnail; 360° preload ẩn sau load, hiện khi bấm ô 360° hoặc chạm option ──
     Các lớp media có sẵn trong HTML (lớp 0 hiện, còn lại hidden → ảnh lazy chưa tải). <cylindo-viewer>
     được tạo ẨN sau window.load + idle; hiện khi bấm ô 360° hoặc bấm/chọn option Easify. */
  (function () {
    var box = root.querySelector('[data-ms-plate-box]');
    if (!box) return;
    var code = root.getAttribute('data-cylindo');
    var q = function (s) { return root.querySelector(s); };
    var layers = Array.prototype.slice.call(box.querySelectorAll('[data-ms-media]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ms-thumb]'));
    var live = q('[data-ms-plate-live]');
    var viewer = null, features = {}, ok = !!code, on = false, painted = false, cur = 0;

    function pauseVideos() { layers.forEach(function (l) { var v = l.querySelector('video'); if (v) v.pause(); }); }
    function markThumbs() {
      thumbs.forEach(function (t) {
        var k = t.getAttribute('data-ms-thumb');
        t.setAttribute('aria-pressed', String(on ? k === '360' : k === String(cur)));
      });
    }
    function showMedia(i) {
      cur = i;
      layers.forEach(function (l, j) { l.hidden = j !== i; });
      pauseVideos();
      markThumbs();
    }
    function setMode(next) {
      on = next;
      box.classList.toggle('is-360', on);
      root.querySelectorAll('[data-ms-needs360]').forEach(function (b) { b.hidden = !on; });
      if (on) pauseVideos();
      if (live) live.textContent = live.getAttribute(on ? 'data-live-360' : 'data-live-photo');
      markThumbs();
    }
    function applyFeatures() {
      if (!viewer) return;
      var apply = function () { viewer.features = Object.assign({}, viewer.features || {}, features); };
      customElements.get('cylindo-viewer') ? apply() : customElements.whenDefined('cylindo-viewer').then(apply);
    }
    /* Đợi frame đầu vẽ xong (canvas/img trong shadow DOM) rồi mới coi là sẵn; trần 2.5s. */
    function whenPainted(cb) {
      var t0 = Date.now();
      (function poll() {
        var sr = viewer && viewer.shadowRoot;
        var im = sr && Array.prototype.find.call(sr.querySelectorAll('img'), function (i) { return i.complete && i.naturalWidth > 0; });
        if (im || sr && sr.querySelector('canvas') || Date.now() - t0 > 2500) { painted = true; return cb(); }
        setTimeout(poll, 100);
      })();
    }
    function ensureViewer() {
      if (!ok || viewer) return;
      viewer = document.createElement('cylindo-viewer');
      viewer.setAttribute('customer-id', '9633');
      viewer.setAttribute('code', code);
      viewer.setAttribute('data-ms-viewer', '');
      box.appendChild(viewer);                       // sau các lớp media → nằm trên
      applyFeatures();
      whenPainted(function () {});
      setTimeout(function () { if (viewer && !customElements.get('cylindo-viewer')) giveUp(); }, 8000);
    }
    function activate() {
      if (!ok) return;
      ensureViewer();
      applyFeatures();
      if (on || painted) { setMode(true); return; }
      whenPainted(function () { if (ok) setMode(true); });
    }
    function giveUp() {
      ok = false;
      if (viewer) { viewer.remove(); viewer = null; }
      setMode(false);
      root.querySelectorAll('[data-ms-thumb="360"], [data-ms-needs360]').forEach(function (b) { b.remove(); });
      if (live) live.remove();
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var k = t.getAttribute('data-ms-thumb');
        if (k === '360') { activate(); return; }
        setMode(false); showMedia(+k);
      });
    });
    var bFull = q('[data-ms-full]'); if (bFull) bFull.addEventListener('click', function () { if (viewer) viewer.fullscreen = true; });
    var bAr = q('[data-ms-ar]'); if (bAr) bAr.addEventListener('click', function () { if (viewer) viewer.ar = true; });
    var bShare = q('[data-ms-share]'); if (bShare) bShare.addEventListener('click', function () {
      var lab = q('[data-ms-share-lab]');
      var p = navigator.clipboard ? navigator.clipboard.writeText(location.href) : Promise.reject();
      p.then(function () { lab.textContent = 'Link copied'; }, function () { lab.textContent = 'Copy failed'; });
      setTimeout(function () { lab.textContent = 'Share'; }, 2000);
    });

    /* Easify → Cylindo: nhãn option → feature (nhãn thật đổi theo sp, map theo từ khoá). */
    function featureFor(label) {
      label = label.toLowerCase();
      if (/frame/.test(label)) return 'FRAME';
      if (/leg/.test(label)) return 'LEG FINISH';
      if (/orientation|side/.test(label)) return 'ORIENTATION';
      if (/colou?r|fabric|upholster/.test(label)) return 'UPHOLSTERY';
      return null;
    }
    function clean(v) { return v.replace(/fabric\s*/i, '').replace(/\[\s*\+\s*£?\d+(\.\d{2})?\s*\]/gi, '').trim().toUpperCase(); }
    function scan() {
      var changed = false;
      root.querySelectorAll('.po-field-root, .tpo_option-label').forEach(function (f) {
        var labEl = f.querySelector('.po-label-label, .form__label');
        var key = labEl && featureFor(labEl.textContent || ''); if (!key) return;
        var valEl = f.querySelector('.po-productList-style1Selected, .po-select-selectedValue, .tpo_selected-option');
        if (!valEl) return;
        var c = valEl.cloneNode(true); Array.prototype.forEach.call(c.querySelectorAll('*'), function (x) { x.remove(); });
        var v = clean(c.textContent || ''); if (!v || features[key] === v) return;
        features[key] = v; changed = true;
      });
      if (changed) activate();
    }
    var form = document.getElementById('ms-pd-form');
    if (form) {
      new MutationObserver(scan).observe(form, { childList: true, subtree: true, characterData: true }); scan();
      // bấm vào ô option (mở picker) là đủ để hiện mô hình — viewer đã preload nên hiện ngay
      form.addEventListener('click', function (e) { if (e.target.closest('.po-field-root, .tpo_option-label')) activate(); });
    }
    /* Picker của Easify render ngoài form (portal ở body): mỗi lần khách CHỌN một item — kể cả chọn lại
       cùng màu sau khi đã xem ảnh — đều bật lại 360° và cuộn HERO (title + Plate 1) lên ngay dưới header sticky
       (yêu cầu 2026-09-18: phải thấy cả title, không chỉ nửa mô hình). scroll-margin-top của .ms-pd__hero = --ms-stick.
       Cuộn KHÔNG chờ cờ `on`: viewer cần tới 2.5s để "painted", chờ nó thì thực tế không bao giờ cuộn. */
    var hero = root.querySelector('.ms-pd__hero') || box;
    /* TẮT 2026-10-18 (yêu cầu user): chọn màu không cuộn trang lên hero nữa. Bật lại = xoá 'return;' */
    function reveal() { return; hero.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
    function whenPickerClosed(cb, t0) {   // picker (modal) đóng — item biến mất — rồi mới cuộn; trần 2s
      t0 = t0 || Date.now();
      if (!document.querySelector('label.po-productListItem-itemContainer') || Date.now() - t0 > 2000) return cb();
      setTimeout(function () { whenPickerClosed(cb, t0); }, 100);
    }
    // CAPTURE phase: picker của Easify chặn propagation nên listener bubbling ở document không bao giờ nhận click.
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[class*="po-productListItem"], [class*="po-optionItem"], [class*="po-select-option"], .tpo_option-type-selection')) return;
      activate();
      setTimeout(function () { whenPickerClosed(function () { scan(); reveal(); }); }, 150);
    }, true);

    /* Không có frame cho code này → bỏ hẳn 360°, giữ ảnh. Có → preload ẨN sau window.load + idle. */
    if (ok) {
      fetch('https://content.cylindo.com/api/v2/9633/products/' + encodeURIComponent(code) + '/frames/1?size=10', { method: 'HEAD' })
        .then(function (r) { if (!r.ok) { giveUp(); return; } schedulePreload(); }, function () { schedulePreload(); });
    }
    function schedulePreload() {
      var go = function () { ('requestIdleCallback' in window) ? requestIdleCallback(ensureViewer, { timeout: 3000 }) : setTimeout(ensureViewer, 1200); };
      document.readyState === 'complete' ? go() : window.addEventListener('load', go, { once: true });
    }
    if (!layers.length) activate();     // không có media nào → viewer là thứ duy nhất để xem
  })();

  /* ── 1b. "Choose options" (hero + sticky) — đi từng bước theo trạng thái option Easify:
       mỗi lần bấm mở option ĐẦU TIÊN chưa chọn (chưa chọn màu thì vẫn mở màu); mọi option đã chọn
       → cuộn tới nút Add to basket. Easify chưa render → link nhảy tới #ms-pd-buy như bình thường. ── */
  (function () {
    var buy = document.getElementById('ms-pd-buy');
    if (!buy) return;
    var btns = root.querySelectorAll('[data-ms-choose]');
    var atc = buy.querySelector('.ms-pd__atc');
    function fields() { return Array.prototype.slice.call(buy.querySelectorAll('.po-field-root, .tpo_option-label')); }
    function hasValue(f) {
      var v = f.querySelector('.po-productList-style1Selected, .po-select-selectedValue, .tpo_selected-option');
      if (v && v.textContent.trim()) return true;
      var i = f.querySelector('input.tpo_hidden-checkbox, input.tpo_option-dropdown');
      return !!(i && i.value && i.value.trim());
    }
    function nextField() { return fields().filter(function (f) { return !hasValue(f); })[0] || null; }
    function opener(f) { return f.querySelector('.po-productList-openButtonStyle1, .po-dropdown-selectWrapper, [role="button"], input.tpo_option-dropdown'); }
    function relabel() {
      if (!fields().length) return;
      var done = !nextField();
      btns.forEach(function (a) { a.textContent = done ? 'Continue to basket' : 'Choose options'; });
    }
    btns.forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (!fields().length) return;                 // Easify chưa render → nhảy tới Order
        e.preventDefault();
        var f = nextField();
        if (f) { var o = opener(f); if (o) o.click(); return; }
        if (atc) { atc.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); atc.focus({ preventScroll: true }); }
      });
    });
    var form = document.getElementById('ms-pd-form');
    if (form) new MutationObserver(relabel).observe(form, { childList: true, subtree: true, characterData: true });
    relabel();
  })();

  /* ── 1c. GIÁ THEO OPTION EASIFY — Easify render "Total price £1,011.00" (.po-priceSummary-price, ẩn bằng CSS)
       trong form và bắn 'easify:options-change'. Đọc tổng đó, delta = tổng − giá gốc, cộng vào mọi [data-ms-price]
       (giá hero, giá was, nhãn ATC, sticky), tính lại dòng trả góp, báo 'ms:price' cho Loxa. Không có summary
       (chưa chọn / option không phụ phí) → về giá gốc.
       ponytail: parse "£1,011.00" kiểu en-GB (phẩy nghìn, chấm thập phân) — đủ cho market GB. ── */
  (function () {
    var form = document.getElementById('ms-pd-form'); if (!form) return;
    var els = root.querySelectorAll('[data-ms-price]'), monthly = root.querySelector('[data-ms-monthly]');
    var base = +root.getAttribute('data-price'), months = +root.getAttribute('data-months') || 48, last = base;
    var sym = (els[0] ? els[0].textContent : '£').replace(/[\d.,\s]/g, '') || '£';
    function money(pence) { return sym + (pence / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function update() {
      var sum = form.querySelector('.po-priceSummary-price'), total = base;
      if (sum) {
        var n = parseFloat(sum.textContent.replace(/[^\d.]/g, ''));
        if (isFinite(n)) total = Math.round(n * 100);
      }
      if (total === last) return;
      last = total;
      var delta = total - base;
      els.forEach(function (el) { el.textContent = money(+el.getAttribute('data-ms-price') + delta); });
      if (monthly) monthly.textContent = money(Math.round(total / months));
      document.dispatchEvent(new CustomEvent('ms:price', { detail: { total: total / 100 } }));
    }
    document.addEventListener('easify:options-change', function () { setTimeout(update, 50); });
    new MutationObserver(update).observe(form, { childList: true, subtree: true, characterData: true });
  })();

  /* ── 2. SKELETON EASIFY ────────────────────────────────────────────────── */
  (function () {
    var ez = root.querySelector('[data-ms-ez]');
    if (!ez) return;
    function loaded() { ez.classList.add('is-loaded'); ez.removeAttribute('aria-busy'); }
    var mo = new MutationObserver(function () {
      if (ez.querySelector('.po-field-root, [class*="tpo_option"]')) { loaded(); mo.disconnect(); }
    });
    mo.observe(ez, { childList: true, subtree: true });
    if (ez.querySelector('.po-field-root, [class*="tpo_option"]')) loaded();
    setTimeout(loaded, 10000);   // app không tới: bỏ skeleton, không giả vờ đang tải
  })();

  /* ── 3. INFORMATION POPUPS ─────────────────────────────────────────────── */
  (function () {
    root.querySelectorAll('[data-ms-dialog]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = document.getElementById(b.getAttribute('data-ms-dialog'));
        if (d && d.showModal) d.showModal();
      });
    });
    root.querySelectorAll('dialog.ms-pd__modal').forEach(function (d) {
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
      var x = d.querySelector('[data-ms-close]'); if (x) x.addEventListener('click', function () { d.close(); });
    });
  })();

  /* ── 4. FINANCE POPUP — V12 calculator (imm.js) mounted inline in our <dialog> ── */
  (function () {
    var btn = root.querySelector('[data-ms-fin]'), host = document.getElementById('ms-pd-fin-host');
    if (!btn || !host) return;
    var tries = 0, poll = setInterval(function () {
      // 'promo' is a top-level const in the imegamedia snippet (global lexical scope, not window.promo)
      var p = (typeof promo !== 'undefined' && promo.placements && promo.placements[0]) || null;
      if (!p) { if (++tries > 40) clearInterval(poll); return; }   // SDK blocked / no config → button stays hidden
      clearInterval(poll);
      if (!p.financeIsAvailable()) return;                          // price outside the lender's £min–£max
      btn.querySelector('span').textContent = 'Finance from ' + p.minInstalment() + '/month';
      btn.hidden = false;
      btn.addEventListener('click', function () {                    // runs after the generic showModal() handler
        if (host.querySelector('iframe')) return;
        p.data.modal.position = 'INLINE';                            // SDK: inline → no overlay, 100% width, auto height
        p.insertElem = '#' + host.id;
        p.createInlineModal();
        var ifr = host.querySelector('iframe'), doc = ifr && ifr.contentDocument;
        if (!doc) return;
        doc.head.insertAdjacentHTML('beforeend', '<style>main{overflow:visible}</style>');
        // The SDK doc.write()s without a doctype → quirks mode → html/body are locked to the iframe height, so
        // no ResizeObserver target grows with the content. ponytail: poll scrollHeight while the dialog is open.
        var dlg = host.closest('dialog'), last = 0;
        var fit = function () { var h = doc.body.scrollHeight; if (h !== last) { last = h; ifr.style.height = h + 'px'; } };
        var arm = function () { var t = setInterval(fit, 250); dlg.addEventListener('close', function () { clearInterval(t); }, { once: true }); };
        arm(); btn.addEventListener('click', arm);
      });
    }, 300);
  })();

  /* ── 5. BADGE SAO (Judge.me, dưới H1) → cuộn tới ĐẦU section Reviews (số + tiêu đề), không tới widget.
       Capture phase + stopPropagation: Judge.me gắn handler cuộn-tới-widget ngay trên badge, nếu để nó chạy
       thì tiêu đề section bị khuất phía trên (đo được widgetTop=30, revTop=-104). ── */
  (function () {
    var rev = document.getElementById('ms-pd-reviews'); if (!rev) return;
    root.addEventListener('click', function (e) {
      if (!e.target.closest('.jdgm-prev-badge')) return;
      e.preventDefault(); e.stopPropagation();
      rev.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }, true);
  })();
})();
